<template>
  <!-- 添加或修改业务对话框 -->
  <el-dialog
    :title="title"
    :visible.sync="open"
    width="700px"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form ref="track" v-model="track">
      <el-row>
        <el-form-item label="当前所处阶段" label-width="150px" :required="true">
          <el-select
            v-model="track.step"
            placeholder="请选择"
            clearable
            filterable
            style="width: 350px"
          >
            <el-option
              v-for="item in trackJd"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" label-width="150px" :required="true">
          <el-date-picker
            style="width: 350px"
            v-model="track.startTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyyMMdd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" label-width="150px" :required="true">
          <el-date-picker
            style="width: 350px"
            v-model="track.endTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyyMMdd"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="面临的困难或问题" label-width="150px" :required="true">
          <el-input v-model="track.problems" style="width: 350px" />
        </el-form-item>
        <el-form-item label="是否存在延期风险" label-width="150px" :required="true">
          <el-input v-model="track.risk" style="width: 350px" />
        </el-form-item>
        <el-form-item label="目前完成情况" label-width="150px" :required="true">
          <el-input
            v-model="track.courseComplete"
            style="width: 350px"
            type="textarea"
            maxlength="100"
            show-word-limit
            :rows="5"
          />
        </el-form-item>
        <el-form-item label="导师辅导情况" label-width="150px">
          <el-input
            v-model="track.tutorCoach"
            style="width: 350px"
            type="textarea"
            maxlength="100"
            show-word-limit
            :rows="5"
          />
        </el-form-item>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>
    <script>
import { fetchQuestionJd } from "@/api/common";
import { trackAdd } from "@/api/trackMonth";
export default {
  name: "trackEdit",
  data() {
    return {
      // 弹出层标题
      title: "编辑", // 是否显示弹出层
      open: false, // 表单参数
      track: {
        courseId: "",
      },
      trackJd: [],
    };
  },
  created() {
    fetchQuestionJd().then((res) => {
      this.trackJd = res.data;
    });
  },
  methods: {
    init(courseId, track) {
      this.open = true;
      this.track = track;
      this.track.courseId = courseId;
    },
    cancel() {
      this.open = false;
    } /** 提交按钮 */,
    submitForm() {
      trackAdd(this.track).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.open = false;
          this.$parent.getlist();
        } else {
          this.$notify({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>